import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';

// Auth pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyEmail from './pages/auth/VerifyEmail';

// Dashboard pages
import Dashboard from './pages/dashboard/Dashboard';
import WAAccounts from './pages/accounts/WAAccounts';
import Chats from './pages/messages/Chats';
import ContactsPage from './pages/contacts/ContactsPage';
import CampaignsPage from './pages/campaigns/CampaignsPage';
import AssistantsPage from './pages/assistants/AssistantsPage';
import IntegrationsPage from './pages/integrations/IntegrationsPage';
import Finance from './pages/finance/Finance';
import Settings from './pages/settings/Settings';

// Campaign analysis pages
import CampaignAnalysis from './pages/CampaignAnalysis';
import CreateAnalysisTask from './components/CreateAnalysisTask';
import TaskProgress from './components/TaskProgress';
import TaskResults from './components/TaskResults';

// Auth guard component
import ProtectedRoute from './components/ProtectedRoute';
import PublicCampaignChats from './pages/public/PublicCampaignChats';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Routes>
        {/* Public routes - these use a container with maxWidth="lg" */}
        <Route path="/login" element={
          <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 4 }}>
            <Login />
          </Container>
        } />
        <Route path="/register" element={
          <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 4 }}>
            <Register />
          </Container>
        } />
        <Route path="/forgot-password" element={
          <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 4 }}>
            <ForgotPassword />
          </Container>
        } />
        <Route path="/reset-password/:token" element={
          <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 4 }}>
            <ResetPassword />
          </Container>
        } />
        <Route path="/verify-email/:token" element={
          <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 4 }}>
            <VerifyEmail />
          </Container>
        } />

        {/* Protected routes - these use full width */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />

        <Route path="/accounts" element={
          <ProtectedRoute>
            <WAAccounts />
          </ProtectedRoute>
        } />

        <Route path="/messages" element={
          <ProtectedRoute>
            <Chats />
          </ProtectedRoute>
        } />

        <Route path="/contacts" element={
          <ProtectedRoute>
            <ContactsPage />
          </ProtectedRoute>
        } />

        <Route path="/campaigns" element={
          <ProtectedRoute>
            <CampaignsPage />
          </ProtectedRoute>
        } />

        <Route path="/assistants" element={
          <ProtectedRoute>
            <AssistantsPage />
          </ProtectedRoute>
        } />

        <Route path="/integrations" element={
          <ProtectedRoute>
            <IntegrationsPage />
          </ProtectedRoute>
        } />

        <Route path="/finance" element={
          <ProtectedRoute>
            <Finance />
          </ProtectedRoute>
        } />

        <Route path="/settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />

        {/* Campaign Analysis */}
        <Route path="/campaign-analysis" element={
          <ProtectedRoute>
            <CampaignAnalysis />
          </ProtectedRoute>
        } />
        <Route path="/campaign-analysis/create" element={
          <ProtectedRoute>
            <CreateAnalysisTask />
          </ProtectedRoute>
        } />
        <Route path="/campaign-analysis/:id/progress" element={
          <ProtectedRoute>
            <TaskProgress />
          </ProtectedRoute>
        } />
        <Route path="/campaign-analysis/:id/results" element={
          <ProtectedRoute>
            <TaskResults />
          </ProtectedRoute>
        } />

        {/* Public share route (no auth) */}
        <Route path="/public/campaign/:id/:token" element={<PublicCampaignChats />} />

        {/* Redirect to login by default */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
